import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { User } from '../types';

interface AuthState {
    user: User | null;
    setUser: (user: User | null) => void;
    isAuthenticated: () => boolean;
    logout: () => void;
}

export const useAuthStore = create<AuthState>()(
    persist(
        (set, get) => ({
            user: null,
            setUser: (user) => set({ user }),
            isAuthenticated: () => !!get().user,
            logout: () => set({ user: null }),
        }),
        {
            name: 'gstr-auth-session',
        }
    )
);
